import '../../../resource/styles/submodal.scss';

class SubModal{
	constructor(){}
	showModal ()
	{
		if($('#overlaySubModal').length == 0)
		{
			$('body').append(this.getDom());
		}
		NeuModal.show({
			type: "custom",
			id: 'subModal',
			class: 'sub-modal',
			contentId: "overlaySubModal",
			isCloseButton: false
		});
	}

	getDom ()
	{
		let str = `<div id="overlaySubModal" class="custom" style="display: none;">
								<div class="signin-logo"><img src="${config.LOC_SERVER}espnplayer/site_4/images/signin_logo.svg" border="0" /></div>
								<div class="suboverlay"><img src="${config.LOC_SERVER}espnplayer/site_4/images/sub_overlay_bg.png" border="0" /></div>
								<div class="info">
									<div class="title">${NEU.getLocalizedString("sub_modal_title")}</div>
									<div class="desc">${NEU.getLocalizedString("sub_modal_desc")}</div>
									<div class="button">
										<a href="/packages" class="subscribe">${NEU.getLocalizedString("sub_modal_subscribe")}</a>
										${client.isLoggedIn == true ? `` : `
											<div class="extra">
												<span class="already">${NEU.getLocalizedString("sub_modal_already_subscribe")}</span>
												<a href="javascript:NeuModal.hide('subModal');showSignIn();" class="signin">${NEU.getLocalizedString("sub_modal_signin")}</a>
											</div>`}
									</div>
								</div>
							</div>`;
		return str;
	}
}

window.showSubModal = new SubModal();